import { colors } from '@/constants';
import styled, { css } from 'styled-components';

export const SubContainer = styled.div<{ direction?: string }>`
  background-color: ${colors.brand.white};
  padding: ${(props) => (props.direction ? 0 : 12)}px;
  display: grid;
  grid-template-columns: 1fr;
  flex-direction: ${(props) => props.direction || 'column'};
  justify-content: space-between;
  align-items: stretch;
  ${(props) =>
    props.direction === 'row' &&
    css`
      justify-content: center;
    `};
`;

export const IconContainer = styled.div<{ $backgroundcolor?: string }>`
  width: 32px;
  height: 32px;
  display: flex;

  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background-color: ${(props) => props.$backgroundcolor || colors.gray.gray10};
`;

export const TopContainer = styled.div`
  display: grid;
  grid-template-columns: auto 3fr 4fr;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
`;

export const BottomContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 18fr;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 6px;
`;

export const RegularTag = styled.span<{ $backgroundcolor?: string; $color?: string; $width?: string; $justifyEnd?: boolean }>`
  border-radius: 3px;
  color: ${(props) => props.$color || colors.brand.grafite};
  font-size: 11px;
  font-weight: 500;
  padding: 3px 8px;
  ${(props) =>
    props.$width &&
    css`
      width: fit-content;
    `}
  ${(props) =>
    props?.$justifyEnd
      ? css`
          display: flex;
          align-self: center;
          justify-self: flex-end;
          flex-wrap: wrap;
        `
      : css`
          text-align: center;
        `}
  /* text-align: center; */
  line-height: 13px;
  background-color: ${(props) => props.$backgroundcolor || colors.gray.gray10};
  font-family: Roboto, sans-serif;
  margin-top: 6px;
`;

export const OrderNumberContainer = styled.div`
  display: flex;
  margin-bottom: 4px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const OrderNumberSubContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const OrderNumber = styled.span<{ $color?: string; $weight?: number }>`
  font-size: 12px;
  font-weight: ${(props) => props.$weight || 400};
  font-family: Roboto, sans-serif;
  color: ${(props) => props.$color || colors.grey3};
`;

export const Divider = styled.div<{ $size?: number; $color?: string }>`
  width: ${(props) => `${props.$size}px` || '32px'};
  ${(props) =>
    props.color &&
    css`
      height: 1px;
      width: 100%;
      background-color: ${props.$color};
      margin-top: 10px;
      border-radius: 6px;
    `};
`;

export const SeparatorContainer = styled.div`
  padding: 0 20px;
`;

export const Separator = styled.div`
  height: 1px;
  background-color: ${colors.background1};
`;

export const BlockContainer = styled.div<{ $showMagentoNumber?: boolean }>`
  display: grid;
  grid-template-columns: ${(props) => (props.$showMagentoNumber ? '7fr auto 6fr' : '12fr 12fr')};
  align-items: center;
  justify-content: space-between;
`;
